import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, TextBox } from '../../components/imports';
// import useDisplayValue from '../../hooks/useDisplayValue';
// import useMouse from '../../hooks/useMouse';

const Content = () => {

  const heroRef = useRef(null);
  const lenaBagRef = useRef(null);

  // const { formattingFn } = useDisplayValue("");
  // const { toDefault, toPlay } = useMouse();

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>



          <MotionContent imgRef={lenaBagRef} height={"height"} className="" refDiv={require('./_cover.jpg')}>
            <ImageMedia
              key={"LenaHoldingBag"}
              src={require('./_cover.jpg')}
              className="full"
            />
          </MotionContent>
          {/* <MotionContent imgRef={lenaBagRef} height={"height"} className=""
            refDiv={require('./assets/CSMNC_SCN01_R03.png')}>
            <ImageMedia
              key={"BottleShot"}
              src={require('./assets/CSMNC_SCN01_R03.png')}
              className="full"
            />
          </MotionContent> */}

          {/*  <div className='relative flex flex-col lg:flex-row w-full items-start justify-start gap-4 h-full'>
            <div className='flex max-lg:portrait:w-full max-md:portrait:bg-white center min-w-[30vw] relative lg:min-h-[150vh] max-lg:portrait:mt-40 h-full md:landscape:items-start md:landscape:justify-start'>
              <div className='stickyVideo sticky top-0 flex center overflow-x-clip'>
                <div className='h-[100vh] max-lg:portrait:h-[80vh] mx-auto flex center relative overflow-clip  w-full border border1 '>
                  <video onMouseEnter={toPlay} onMouseLeave={toDefault} controls={true} muted={false} loop={false} src={require('./assets/bts.mp4')} className='flex h-full ' />
                </div>
              </div>
            </div>
            <div className='flex flex-col w-full resp lg:!pl-0 lg:!ml-0 min-h-[150vh] '>
              <Section padded className={"items-center w-full lg:pt-[40vh] h-fit bg-transparent"}>
                <div className='group text-left w-full flex flex-col padding h-fit'>
                  <h2 className='max-w-[20ch] w-fit text-balance'>Vidéo officielle de lancement <span className='!capitalize'>{thisProject.client}</span>.</h2>

                  <button className='flex center size-12 relative'>
                    <div className='absolute bg-red-500 animate-pulse inset-2 group-hover:inset-0 group-hover:opacity-100 quick rounded-full' />
                    <Link target='_blank' to={"https://www.instagram.com/p/CHWbRc8lDa7/"} className='relative group-hover:bg-gray-500/5 quick nowrap button space-x-2 w-fit px-2 py-2 rounded-full '>
                      <i className='inline-flex center size-10 border1 border rounded-full rotate-45 animate-pulse ri-arrow-up-line' />
                    </Link>
                  </button>
                </div>

                <div className='grid grid-cols-2 lg:grid-cols-4 lg:h-[100svh]= gap-6 paddingX w-full relative mt-8'>
                  <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                    <h2 className='w-[4ch]'>
                      <CountUp start={1} end={46000} duration='2.5' className='m-0 p-0' scrollSpyOnce enableScrollSpy formattingFn={formattingFn} useEasing />
                    </h2>
                    <h4 className='leading-none'>vues Instagram</h4>
                  </li>
                  <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                    <h2 className='w-[4ch]'>
                      <CountUp start={1} end={55} duration='2.5' className='m-0 p-0' scrollSpyOnce enableScrollSpy formattingFn={formattingFn} useEasing />
                    </h2>
                    <h4 className='leading-none'>images produites</h4>
                  </li>
                </div>
              </Section>
            </div>
          </div> */}

          <div>
            <TextBox
              title={"Une D.A prête pour l'Editorial"}
              descr={"Voici une production articulée autour d'une direction artistique vibrante et épurée, sublimée par un étalonnage sur mesure mettant en valeur les merveilleuses réalisations d'Anima Iris."}
              className={"resp paddingY"}
            />
            <ImageMedia src={require('./assets/grading.JPG')} />
          </div>
          <div className='grid grid-cols-1 lg:grid-cols-2 w-full bg-black pt-12'>
            <MotionContent imgRef={heroRef} height={"lg:h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img" + thisProject.client}
                src={require('./assets/AnimaIris, 14.jpg')}
                className="relative md:landscape:scale-[110%] full object-contain object-center"
              />
            </MotionContent>
            <MotionContent imgRef={heroRef} height={"h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img2" + thisProject.client}
                src={require('./assets/_cover.jpg')}
                className="relative md:landscape:scale-[110%] full object-cover lg:object-contain object-center"
              />
            </MotionContent>
          </div>
        </div>
      )}
    </ThisProject>
  )
}

export default Content